"use strict";
exports.__esModule = true;
exports.PopUpLegend = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var StaticLegend_1 = require("../StaticLegend");
var LegendDialog_1 = require("./LegendDialog");
var RowLegend_1 = require("./RowLegend");
var PAGINATION_HEIGHT = 34;
/**
 * @internal
 */
exports.PopUpLegend = function (props) {
    var name = props.name, maxRows = props.maxRows, enableBorderRadius = props.enableBorderRadius, series = props.series, onLegendItemClick = props.onLegendItemClick, containerId = props.containerId, customComponent = props.customComponent, customComponentName = props.customComponentName;
    var intl = react_intl_1.useIntl();
    var _a = react_1.useState(false), isDialogOpen = _a[0], setDialogOpen = _a[1];
    var _b = react_1.useState(1), page = _b[0], setPage = _b[1];
    var dialogTitle = (page === 1 && customComponentName) || name || intl.formatMessage({ id: "properties.legend.title" });
    var onCloseDialog = function () {
        setDialogOpen(false);
        setPage(1);
    };
    return (react_1["default"].createElement("div", null,
        react_1["default"].createElement(RowLegend_1.RowLegend, { legendLabel: name, maxRowsCount: maxRows, series: tslib_1.__spreadArrays(series), onDialogIconClick: function () {
                setDialogOpen(function (prevState) { return !prevState; });
            }, onLegendItemClick: onLegendItemClick, enableBorderRadius: enableBorderRadius, isActive: isDialogOpen }),
        react_1["default"].createElement(LegendDialog_1.LegendDialog, { name: dialogTitle, alignTo: "." + containerId, isOpen: isDialogOpen, onCloseDialog: onCloseDialog },
            react_1["default"].createElement(StaticLegend_1.StaticLegend, { containerHeight: 260, series: tslib_1.__spreadArrays(series), position: "dialog", buttonOrientation: "leftRight", onItemClick: onLegendItemClick, shouldFillAvailableSpace: false, enableBorderRadius: enableBorderRadius, paginationHeight: PAGINATION_HEIGHT, customComponent: customComponent, onPageChanged: setPage }))));
};
//# sourceMappingURL=PopUpLegend.js.map